import BaseView from '../../../js/base-view';

const SELECTOR_HEADBAND = '.home-header__headband'
const SELECTOR_FIGURE =  '.home-header-article__image'

export default class HomeHeader extends BaseView {
	init() {
		this.refs = {
			headband: this.el.querySelector(SELECTOR_HEADBAND),
			figure: this.el.querySelector(SELECTOR_FIGURE),
		};

		this.viewport.on('changeFast', this.onResize.bind(this));
	}

	onResize() {
		if ( ! this.refs.headband || ! this.refs.figure ) {
			return;
		}
		const height = this.refs.figure.getBoundingClientRect().top - this.el.getBoundingClientRect().top;
		this.refs.headband.style.height = `${height}px`
	}
}
